var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BorrarModalComponent,{attrs:{"name":'delete-descuento-' + _vm.voucher.id,"title":"Eliminar Descuento"},on:{"confirm":_setup.handleConfirm,"cancel":_setup.handleCancel,"close":_setup.handleCancel}},[_vm._v("\n    ¿Estás seguro de eliminar el descuento "+_vm._s(_vm.voucher.name)+"?\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }